import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./Fota.module.scss";
import { Link, useHistory } from "react-router-dom";
import NewTableList from "components/common/NewTableList";
import { getRequest as getRequestForPrice } from "services/axiosBaseClient";
// import ServiceRequestViewMaster from "components/common/ServiceRequestViewTableMaster";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";

var tempTigger;

export default function FirmwareUpgrade(props) {
  const history = useHistory();
  const [FotaListData, setFotaListData] = useState([]);
  const [FotaCountData, setFotaCountData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [checkboxData, setCheckboxData] = useState([]);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    tempTigger = !history?.location?.compomentRenderType
      ? "init"
      : history?.location?.compomentRenderType === "amhitted"
      ? "amhitted"
      : history?.location?.compomentRenderType === "view"
      ? "view"
      : "amhitted";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  const FotaData = [
    {
      stationID: "Test",
      make: "Amaron",
      model: "Amaron",
      state: "Andhra Pradesh",
      stationStatus: "Online",
      firmwareStatus: "Up to Date",
      version: "V 2.4",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test1",
      make: "Exicom",
      model: "Exicom",
      state: "Assam",
      stationStatus: "Offline",
      firmwareStatus: "In progress",
      version: "V 1.6",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test2",
      make: "Amaron",
      model: "Amaron",
      state: "Karnataka",
      stationStatus: "Online",
      firmwareStatus: "In progress",
      version: "V 2.7",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test3",
      make: "Exicom",
      model: "Exicom",
      state: "Bihar",
      stationStatus: "Online",
      firmwareStatus: "In progress",
      version: "V 1.5",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test4",
      make: "Amaron",
      model: "Amaron",
      state: "Delhi",
      stationStatus: "Offline",
      firmwareStatus: "Up To Date",
      version: "V 1.0",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test5",
      make: "Exicom",
      model: "Exicom",
      state: "Maharastra",
      stationStatus: "Offline",
      firmwareStatus: "In progress",
      version: "V 1.5",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test6",
      make: "Exicom",
      model: "Exicom",
      state: "Karnataka",
      stationStatus: "Online",
      firmwareStatus: "Up To Date",
      version: "V 2.0",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test7",
      make: "Amaron",
      model: "Amaron",
      state: "Delhi",
      stationStatus: "Online",
      firmwareStatus: "In progress",
      version: "V 1.8",
      action: "XXXXX",
      checked: false,
    },
    {
      stationID: "Test8",
      make: "Amaron",
      model: "Amaron",
      state: "Goa",
      stationStatus: "Online",
      firmwareStatus: "Up To Date",
      version: "V 2.5",
      action: "XXXXX",
      checked: false,
    },
  ];

  const ViewSwapStationHandle = (data) => {
    history.push({
      pathname: "/Fota/ViewSwapStation/" + data?.row?.original?.stationID,
      state: { firmwareData: FotaData },
    });
  };
  const getFotaList = useCallback(async (searchString) => {
    const filteredData = FotaData.filter((item) =>
      item.stationID.toLowerCase().includes(searchString.toLowerCase())
    );

    return Promise.resolve(filteredData);
  }, []);

  const handleCheckBox = (row) => {
    const updatedData = FotaListData.map((item) => {
      if (item.stationID === row.row.original.stationID) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });

    setFotaListData(updatedData);

    const checkedItems = updatedData.filter((item) => item.checked);
    if (checkedItems.length > 0) {
      setCheckboxData(checkedItems);
      setChecked(true);
    } else {
      setCheckboxData([]);
      setChecked(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
    // getPriceList();
    setFotaListData(FotaData);
    setFotaCountData(FotaData.length);
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTabCount", "zoneAsset");
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={() => setSelectAll(!selectAll)}
          style={{ margin: "0px" }}
        />
      ),
      accessor: "checked",
      Cell: (row) => {
        return (
          <>
            <div>
              <input
                defaultChecked={row?.row?.original?.checked || selectAll}
                type="checkbox"
                style={{ margin: "0px" }}
                //  checked={row?.value}
                onChange={() => handleCheckBox(row)}
              />
            </div>
          </>
        );
      },
      // width: "40%",
    },
    {
      Header: "Station ID",
      accessor: "stationID",
      // width: "40%",
    },
    {
      Header: "Make",
      accessor: "make",
    },
    {
      Header: "Model no",
      accessor: "model",
      // width: "40%",
    },
    {
      Header: "Firmware Version",
      accessor: "version",
      // width: "40%",
    },
    {
      Header: "State",
      accessor: "state",
      // width: "40%",
    },
    {
      Header: "Station Status",
      accessor: "stationStatus",
      Cell: (row) => {
        const StationStatus=row.row.original.stationStatus
        return (
          <>
            <div style={{color:StationStatus=="Online"?"rgb(37,171,33)":"red"}}>
             {StationStatus}
            </div>
          </>
        );
      },
      // width: "40%",
    },
    {
      Header: "Firmware Status",
      accessor: "firmwareStatus",
      // width: "40%",
    },
    {
      Header: "Action",
      accessor: "action",
      // width: "40%",
      Cell: (row) => {
        return (
          <>
            <div>
              <img
                src={require("assets/eye.png").default}
                style={{ margin: "8px", cursor: "pointer" }}
                onClick={() => ViewSwapStationHandle(row)}
              ></img>
            </div>
          </>
        );
      },
    },
  ]);

  var searchByKey = () => {};

  return (
    <>
      <NewTableAndSearchMasterFilter
        searchOpts={{
          placeholder: "Search ",
          filter: true,
          onFilterSearch: (searchString) => getFotaList(searchString),
          screentype: "FirmwareUpgrade",
        }}
        tigger={tempTigger}
        columns={columns}
        data={FotaListData}
        paginationDoubleScreen={true}
        swapStationCount={FotaCountData}
       checkBoxData={checkboxData}
       FilterOpts={"FirmwareUpgrade"}
      />
      {/* </div> */}
    </>
  );
}

FirmwareUpgrade.inStorybook = true;
